export default "__VITE_ASSET__0d709652__"